var getAnalyticsVal = function (data, seperator, hasTermsConsentBanner) {
    if (!hasTermsConsentBanner) {
        var dataArr = data.split(seperator);
        dataArr.splice(1, 0, 'sms consent');
        return dataArr.join(seperator);
    }
    // data-subfunction and data-reason when consent banner is present
    return data;
};
export default getAnalyticsVal;
